var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseCurrency',{attrs:{"symbol":_vm.base},on:{"base-change":_vm.onBaseChange}}),_c('div',{staticClass:"grid"},_vm._l((_vm.rates),function(rate,symbol,index){return _c('Currency',{key:index,attrs:{"value":rate,"symbol":symbol,"base":_vm.base}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }